import { useAccountScope } from '../context/AccountScope';
import { useEffect, useRef, useState } from 'react';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
export default function GpsRestartSettings() {
  const { fetch } = useAccountScope();
  const [vehicles, setVehicles] = useState([]);
  const [selection, setSelection] = useState('');
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [now, setNow] = useState(Date.now());
  const abortRef = useRef(null);
  const mounted = useRef(true);
  const vehicle = vehicles.find(v => String(v.id) === selection);
  const wait = Math.max(0, Math.ceil(((vehicle?.waitUntil || 0) - now) / 1000));
  async function load() {
    abortRef.current?.abort();
    const controller = new AbortController(); abortRef.current = controller;
    setLoading(true);
    try {
      const response = await fetch('/api/gps-restart', { headers: headers(), signal: controller.signal });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'No se pudieron consultar tus GPS.');
      if (!controller.signal.aborted) {
        setVehicles(data.vehicles.map(v => ({ ...v, waitUntil: Date.now() + v.retryAfter * 1000 })));
        setError('');
      }
    } catch (cause) {
      if (cause?.name === 'AbortError') return; if (!controller.signal.aborted) setError(cause.message); }
    finally { if (!controller.signal.aborted) setLoading(false); }
  }
  useEffect(() => {
    mounted.current = true;
    load();
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => { mounted.current = false; abortRef.current?.abort(); clearInterval(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function restart() {
    if (!vehicle || busy || loading || wait || !vehicle.online || !vehicle.licenseValid) return;
    if (!window.confirm(`¿Quieres reiniciar el GPS de ${vehicle.name}? La conexión se interrumpirá brevemente.`)) return;
    const target = vehicle.id;
    setBusy(true); setMessage('Enviando solicitud de reinicio…');
    try {
      const response = await fetch(`/api/gps-restart/${target}`, { method: 'POST', headers: headers() });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'No se pudo enviar la solicitud.');
      if (mounted.current) {
        setMessage(result.message);
        setVehicles(prev => prev.map(v => v.id === target ? { ...v, waitUntil: Date.now() + result.retryAfter * 1000 } : v));
        setNow(Date.now());
      }
    } catch (cause) {
      if (cause?.name === 'AbortError') return; if (mounted.current) setMessage(cause.message); }
    finally { if (mounted.current) setBusy(false); }
  }
  return <section>
    <div className="configuration-section-heading"><span>↻</span><div><h2>Reinicio del GPS</h2>
      <p>Reinicia el GPS si presenta problemas de conexión o funcionamiento. Conserva su configuración.</p></div></div>
    <label className="configuration-select-label" htmlFor="restart-vehicle">Activo</label>
    <select id="restart-vehicle" value={selection} disabled={loading || busy}
      onChange={event => { setSelection(event.target.value); setMessage(''); }}>
      <option value="">Selecciona un activo</option>
      {vehicles.map(v => <option key={v.id} value={v.id}>{v.name}{v.plate ? ` · ${v.plate}` : ''}</option>)}
    </select>
    {loading && <p>Consultando conexión…</p>}
    {error && <p className="configuration-error">{error}</p>}
    {vehicle && <>
      {!vehicle.licenseValid ? <p>La licencia del activo no está vigente.</p>
        : !vehicle.online && <p>El GPS debe estar conectado para recibir la solicitud de reinicio.</p>}
      <div className="configuration-restart-actions">
        <button type="button" className="configuration-action" disabled={loading || busy || !vehicle.online || !vehicle.licenseValid || wait > 0}
          onClick={restart}>{busy ? 'Enviando…' : wait > 0 ? `Espera ${wait} s` : 'Reiniciar GPS'}</button>
        <button type="button" className="configuration-action secondary" disabled={loading || busy} onClick={load}>Actualizar conexión</button>
      </div>
    </>}
    {!vehicle && error && <button type="button" className="configuration-action" disabled={loading} onClick={load}>Reintentar</button>}
    {message && <p role="status" aria-live="polite">{message}</p>}
  </section>;
}
